import { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { AdminPermissionsProvider } from "@/project/karuna/contexts/AdminPermissionsContext";

/** Wraps authenticated admin routes with permission context. */
export function AdminPortalShell({ children }: { children?: ReactNode }) {
  return (
    <AdminPermissionsProvider>
      {children ?? <Outlet />}
    </AdminPermissionsProvider>
  );
}
